export default __webpack_public_path__ + "static/media/hc-0.fc10dbe5.mp4";